import { Box, Center, Flex, Text } from '@chakra-ui/react';
import { djs } from '@duke-hq/djs';
import React from 'react';
import type { CourseItemsStatusAccordionLabels, ProcessedUnits, UnitActionsProps } from './types';
import { pxToRem } from '@duke-hq/ui/constants/scalable';

export function SemesterGroupHeader({
  semester,
  units,
  UnitActionsComponent,
  isSkillSet = false,
  l,
}: {
  semester: string;
  units: ProcessedUnits[number];
  UnitActionsComponent?: React.ComponentType<UnitActionsProps>;
  isSkillSet?: boolean;
  l: CourseItemsStatusAccordionLabels;
}): React.ReactElement {
  const semesterReleaseDate = units?.[0]?.semesterReleaseDate;

  let title = l.semester(Number(semester));

  if (semester === '0') {
    title = l.lln;
  } else if (isSkillSet) {
    title = l.skillSetUnits;
  }

  return (
    <Flex
      key={`semester-${semester}`}
      justifyContent="space-between"
      backgroundColor="bg.muted"
      w="full"
    >
      <Flex>
        <Box w="9"></Box>
        <Box p={2}>
          <Text fontWeight="medium" color="fg.muted">
            {title}
          </Text>
        </Box>
      </Flex>
      <Flex>
        <Box p={2} color="fg.emphasis" w={pxToRem(120)}>
          <Text fontWeight="medium" color="fg.muted" textAlign="center">
            {semesterReleaseDate !== null ? djs(semesterReleaseDate).format('D MMM YYYY') : null}
          </Text>
        </Box>
        <Box p={2} w={pxToRem(136)}>
          <Center>
            <Text fontWeight="medium" color="fg.muted">
              {semesterReleaseDate !== null ? l.enrolled : l.notEnrolled}
            </Text>
          </Center>
        </Box>
        {UnitActionsComponent ? <Box p={2} w="14"></Box> : null}
      </Flex>
    </Flex>
  );
}
